import { useMemo } from 'react';
import { getAhaFlag, type AhaFlagId } from '@/lib/feature_flags';

// useAhaFlag — React hook wrapping getAhaFlag.
// Read-once per component mount; flags don't change at runtime in M0/aha v1.
export function useAhaFlag(flag: AhaFlagId): boolean {
  return useMemo(() => getAhaFlag(flag), [flag]);
}
